import type { NotificationBannerRequest } from "@/modules/notificationBanner/api/getNotificationBanner"
import type { QueryKey } from "@tanstack/react-query"

import { NOTIFICATION_BANNER_QUERY_KEY } from "@/modules/notificationBanner/services/constants"

export const getNotificationBannerQueryKey = ({ isBackend, locale }: NotificationBannerRequest): QueryKey => {
  return [NOTIFICATION_BANNER_QUERY_KEY, isBackend, locale]
}
